import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { load as loadParameterList, loadObject, loadProject, filterProject, filterObject, filterType } from '../../../reducers/models/parameter/parameterList'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faDiagramProject, faExpand, faFilter, faPlay } from "@fortawesome/free-solid-svg-icons";
import ModalUpdate from "./ParameterModalUpdate";
import TabBar from "../../../components/ui/TabBar";
import List from "./List";
import InfoNoData from "../../../components/global/InfoNoData";
import FilterUniversal from "../../../components/filter/FilterUniversal";
import ModalAdd from "./ParameterModalAdd";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const dispatch = useDispatch()

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 1, name: "Активные", icon: faPlay, showCount: false, loading: false, loading1: false, loading2: false }
        , { id_tab: 0, name: "Архив", icon: faArchive, showCount: false, loading: false, loading1: false, loading2: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(1);

    function tabHandler(id_tab) {
        setTabSelected(id_tab)
        if (id_tab === 0) {
            if (stateParameterList.listLoaded.filter(a => a.id_tab === 0).length === 0) {
                loadList(0);
            }
        }
    }
    //TAB END

    const stateParameterList = useSelector((state) => state.parameterList);

    useEffect(() => {
        if (stateParameterList.listLoaded.filter(a => a.id_tab === 1).length === 0) {
            loadList(1);
        }
    }, []);

    const [log, setLog] = useState(null);
    const [id, setId] = useState(false);
    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalEditShow, setModalEditShow] = useState(false);

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    function loadList(id_status) {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === id_status) {
                return { ...item, loading: true, loading1: true, loading2: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/parameter/list', { params: { ID_Status: id_status } })
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadParameterList({ list: res.data.Data, id_tab: id_status }));
                    axios.get('/api_tracker/parameter/objectList', { params: { ID_Status: id_status } })
                        .then((res1) => {
                            if (res1.data.Status === 1) {
                                dispatch(loadObject({ list: res1.data.Data, id_tab: id_status }))
                            }
                            else {
                                setLog(res1.data.Error);
                            }

                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading1: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        })
                        .catch((err) => {
                            setLog('Неизвестная ошибка!');
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading1: false }
                                }
                                else {
                                    return item;
                                }
                            }))

                            ErrorAdd(err, window.location.href);
                        });
                    axios.get('/api_tracker/parameter/projectList', { params: { ID_Status: id_status } })
                        .then((res2) => {
                            if (res2.data.Status === 1) {
                                dispatch(loadProject({ list: res2.data.Data, id_tab: id_status }))
                            }
                            else {
                                setLog(res2.data.Error);
                            }

                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading2: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        })
                        .catch((err) => {
                            setLog('Неизвестная ошибка!');
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === id_status) {
                                    return { ...item, loading2: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                            ErrorAdd(err, window.location.href);
                        });
                }
                else {
                    setLog(res.data.Error);
                    setTab(tab_ => tab_.map(item => {
                        if (item.id_tab === id_status) {
                            return { ...item, loading: false, loading1: false, loading2: false }
                        }
                        else {
                            return item;
                        }
                    }))
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_status) {
                        return { ...item, loading: false, loading1: false, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
            });
    }

    function editHandler(id) {
        setId(id);
        setModalEditShow(true);
    }
    /**********************START ФИЛЬТР ПРОЕКТОВ*******************************/
    const [filterProjectList, setFilterProjectList] = useState([]);
    const [filterProjectSelected, setFilterProjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */

        var data = [
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 0).length, id_tab: 0 },
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 1).length, id_tab: 1 },
            { id: 0, name: 'Все проекты', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.All_Project === true).length, id_tab: 0 },
            { id: 0, name: 'Все проекты', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.All_Project === true).length, id_tab: 1 }
        ];

        stateParameterList.listProject.map((item) => {
            if (data.filter(a => a.id === item.ID_Project & a.id_tab === item.id_tab).length === 0) {
                data.push(
                    {
                        id: item.ID_Project,
                        name: item.Name_Project,
                        count: stateParameterList.listProject.filter(a => a.ID_Project === item.ID_Project).length,
                        id_tab: item.id_tab
                    }
                )
            }
        })
        setFilterProjectList(data);

    }, [stateParameterList.listProject]);

    function filterProjectHandler(id_project, id_tab) {

        const val_ = filterProjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_project ? -1 : id_project;

        const list = filterProjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterProject({ id_tab: id_tab, id_project: val_ }));
        setFilterProjectSelected(list);
    }
    /***********************END ФИЛЬТР ПРОЕКТОВ********************************/
    /**********************START ФИЛЬТР ОБЪЕКТОВ*******************************/
    const [filterObjectList, setFilterObjectList] = useState([]);
    const [filterObjectSelected, setFilterObjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */

        var data = [
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 0).length, id_tab: 0 },
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 1).length, id_tab: 1 },
            { id: 0, name: 'Все объекты', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.All_Object === true).length, id_tab: 0 },
            { id: 0, name: 'Все объекты', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.All_Object === true).length, id_tab: 1 }
        ];

        stateParameterList.listObject.map((item) => {
            if (data.filter(a => a.id === item.ID_Object & a.id_tab === item.id_tab).length === 0) {
                data.push(
                    {
                        id: item.ID_Object,
                        name: item.Name_Object,
                        count: stateParameterList.listObject.filter(a => a.ID_Object === item.ID_Object).length,
                        id_tab: item.id_tab
                    }
                )
            }
        })
        setFilterObjectList(data);

    }, [stateParameterList.listObject]);

    function filterObjectHandler(id_object, id_tab) {

        const val_ = filterObjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_object ? -1 : id_object;

        const list = filterObjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterObject({ id_tab: id_tab, id_object: val_ }));
        setFilterObjectSelected(list);
    }
    /***********************END ФИЛЬТР ОБЪЕКТОВ********************************/
    /***********************START ФИЛЬТР ТИПОВ*********************************/
    const [filterTypeList, setFilterTypeList] = useState([]);
    const [filterTypeSelected, setFilterTypeSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }]);

    useEffect(() => {
        /*
            id - ИД проекта
            name - Название проекта
            count - Кол-во элементов в проекте 
        */

        /*
        ID	Name
        1	Логический
        2	Число
        3	Строка
        4	Справочник
        5	Дата
        */

        const data = [
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 0).length, id_tab: 0 },
            { id: -1, name: 'Все', count: stateParameterList.list.filter(a => a.id_tab === 1).length, id_tab: 1 },

            { id: 1, name: 'Логический', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.ID_Type === 1).length, id_tab: 0 },
            { id: 1, name: 'Логический', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.ID_Type === 1).length, id_tab: 1 },

            { id: 2, name: 'Число', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.ID_Type === 2).length, id_tab: 0 },
            { id: 2, name: 'Число', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.ID_Type === 2).length, id_tab: 1 },

            { id: 3, name: 'Строка', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.ID_Type === 3).length, id_tab: 0 },
            { id: 3, name: 'Строка', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.ID_Type === 3).length, id_tab: 1 },

            { id: 4, name: 'Справочник', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.ID_Type === 4).length, id_tab: 0 },
            { id: 4, name: 'Справочник', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.ID_Type === 4).length, id_tab: 1 },

            { id: 5, name: 'Дата', count: stateParameterList.list.filter(a => a.id_tab === 0 & a.ID_Type === 5).length, id_tab: 0 },
            { id: 5, name: 'Дата', count: stateParameterList.list.filter(a => a.id_tab === 1 & a.ID_Type === 5).length, id_tab: 1 },
        ];

        setFilterTypeList(data);

    }, [stateParameterList.list]);

    function filterTypeHandler(id_type, id_tab) {

        const val_ = filterTypeSelected.filter(a => a.id_tab === id_tab)[0].val === id_type ? -1 : id_type;

        const list = filterTypeSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterType({ id_tab: id_tab, id_type: val_ }));
        setFilterTypeSelected(list);
    }
    /************************END ФИЛЬТР ТИПОВ**********************************/

    return (
        <div className='admin_content'>
            {modalAddShow === true && (
                <ModalAdd show={modalAddShow} onHide={() => setModalAddShow(false)} />
            )}
            {modalEditShow === true && stateParameterList.list.filter(a => a.ID === id).length > 0 && (
                <ModalUpdate show={modalEditShow} onHide={() => setModalEditShow(false)} model={stateParameterList.list.filter(a => a.ID === id)[0]} />
            )}
            <div className="mb-20">
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={true} />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                    <div className={filterShow === false ? "d-none" : ""}>
                        <div className="filter-container">
                            <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                            <FilterUniversal filterName='Проекты' filterIcon={faDiagramProject} list={filterProjectList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterProjectHandler} selected={filterProjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            <FilterUniversal filterName='Объекты' filterIcon={faExpand} list={filterObjectList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterObjectHandler} selected={filterObjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            <FilterUniversal filterName='Типы' filterIcon={faExpand} list={filterTypeList.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterTypeHandler} selected={filterTypeSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                        </div>
                    </div>
                    <div className="mt-20">
                        {tab.loading === true ? (
                            <div className="loader_01 mt-30"></div>
                        ) : (
                            stateParameterList.list.filter(a => a.id_tab === tab.id_tab).length === 0 ? (
                                <InfoNoData text="Нет параметров" />
                            ) : (
                                <List key={0}
                                    editHandler={editHandler}
                                    list={stateParameterList.list.filter(a => a.id_tab === tab.id_tab & a.filter_project === false & a.filter_object === false & a.filter_type === false)}
                                    idTab={tab.id_tab}
                                />
                            )
                        )}

                    </div>
                </div>
            ))}
        </div>
    )
}
export default Index;